import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getApiClient, initializeApiClient } from "../../../../Services/apiService";


export const GetAllMP_MR_Item = createAsyncThunk(
  "dropdowns/GetAllMP_MR_Item",
  async (_, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post("api/DropDowns/GetAllMP_MR_Item");

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataaaa");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const DropDownItem = createSlice({
  name: "DropDownItem",
  initialState: {
    DropDownItem: [],
    loadingDropDownItem: false,
    errorDropDownItem: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetAllMP_MR_Item.pending, (state, action) => {
        state.loadingDropDownItem = true;
        state.DropDownItem = action.payload;
        state.errorDropDownItem = null;
      })
      .addCase(GetAllMP_MR_Item.fulfilled, (state, action) => {
        state.loadingDropDownItem = false;
        state.DropDownItem = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetAllMP_MR_Item.rejected, (state, action) => {
        state.loadingDropDownItem = false;
        state.errorDropDownItem = action.payload;
      });
  },
});

export default DropDownItem.reducer;
